<template>
    <div>
    	<div v-if="tradingAccountList.totalLiveAccounts == 0">
			<div class="mainTitle  text-center my-3">
				<h2>{{$t('rb_noTradingAccFound')}} </h2>
			</div>
			<no-trading-account :demo_live_both="''" :totalRecords = "tradingAccountList.totalLiveAccounts"></no-trading-account>
        </div>
		<div v-else-if="(parseInt(tradingAccountList.totalLiveAccounts) == 1) && (allAccountList.totalRecords  == 1)">
			<div class="CustomBlockWidth " >
				<div class=" row justify-content-center">
					<div class=" middleBox">
						<div class="whiteBG p-4"> 
							<div class="card ">
							  <div class="card-body text-center">
								<img src="../../../../static/fxView/images/lost.svg" alt="no account found" class="mb-4" width="200">  
								<p class="mb-3">{{$t('It_oneRecord')}}</p>
								<router-link to="/create-live-account" class="prism_btn btn_sm lift">{{$t('It_liveAcc')}}</router-link>
								<router-link to="/wallet" class="prism_btn btn_sm lift">{{$t('It_wallet')}}</router-link>
							  </div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div  v-else-if="tradingAccountList.totalLiveAccounts  >= 1 && allAccountList.totalRecords  > 1" >
			<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && authComponent && transaction_id != '' && !congModuleIntTransfer)">
				<app-twofa  :call_from="request_page"></app-twofa>
			</div>
			<div v-else>
				<div class="mainTitle text-center mt-4 mb-3"> 
					<h2 class=" mb-3">{{$t('It_internalTransfer')}} </h2>
					<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
					<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
				</div> 
				<!--loader - message--->
				
				<!-------------------->
				<div class="CustomBlockWidth"> 
					<div class=" row justify-content-center">
						<div class="middleBox">
							<div class="whiteBG p-4">
								<!----------------------request form---------------------------------> 
								<div class="partcipate-fund" v-if="transaction_id == '' && !congModuleIntTransfer">
									<!-- <h2 class=" mb-3">{{$t('internalTransfer')}} </h2> -->
									<div class="test text-center" v-if="conversionAmount">
										<span class="checkArea"><feather type="info"></feather></span>
										<p class="mb-3" >
											{{from_currency}} {{parseFloat(amount).toFixed(2)}} {{$t('It_interTransDeducted')}} trading account {{account_id}} and  {{to_currency}} {{parseFloat(responseAmount).toFixed(2)}} {{$t('It_depostotradAcc')}} {{(getWallet(to_account_id))?'wallet '+getWallet(to_account_id).wallet.wallet_no:'trading account '+to_account_id}}
										</p>
										<div class="form-group text-center field-wrapper">
											<button class="prism_btn btn_sm" v-on:click.prevent="submitInternalTransferRequestOtp()">
												<span>{{$t('It_confToTransfer')}}</span>
											</button>
										</div>
										<div class="signupbtn mt-4 text-center">
											<a href="#" class="underline" v-on:click.prevent="conversionAmount = false">{{$t('It_back')}} </a>
										</div>
									</div>
									<div v-else>
										<div class="form-group field-wrapper">
											<account-id></account-id>
										</div><!-- {{parseFloat(fromBalance)}}--{{fromBalance !== ''}}--{{fromBalanceCurr}} -->
										<div class="form-group field-wrapper" v-if="fromBalance != ''">
											<input placeholder=" " type="text" v-model="fromBalanceCurr"  v-validate="{ required: true }" name="fromBalanceCurr" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('fromBalanceCurr') }" ref="fromBalanceCurrInput" readonly />
											<label for="password" class="float-label">{{$t('It_freeMargin')}}</label>
										</div>
										<div class="transferSorry d-flex justify-content-center align-items-center  py-4" v-if="fromBalance !== '' && parseFloat(fromBalance) == 0">
											<div class="text-center">
												<figure class="mb-3 detailsFigure"><img src="../../../../static/fxView/images/transfer.svg" alt="transfer"></figure>
												<p class="text-center" >{{$t('It_interTransSorryMsz')}} </p>
											</div>
										</div>
										<!-- <p v-if="fromBalance !== '' && parseFloat(fromBalance) == 0">{{$t('interTransSorryMsz')}} </p> -->
										<div v-if="fromBalance !== '' && parseFloat(fromBalance) > 0">
											<div class="form-group field-wrapper">
												<input placeholder=" " type="hidden" v-model="to_account_id"  v-validate="{ required: true }" name="to_account_id" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('to_account_id') }" ref="to_account_idInput" readonly />
												
												<div class="customSelect mdb-select md-form float-field form-control" v-on:click.prevent="selectToAccount = !selectToAccount" :class="(selectToAccount?'active' : '') || ((to_account_id == '' && submitted)?'is-invalid' : '')">
													<div class="SelectAcntList SelectAcntList2">
														<div class="d-flex align-items-center justify-content-between" v-if="to_account_id == ''">{{$t('It_transToAcc')}}</div>
														<div class="d-flex align-items-center justify-content-between" v-else>
															<span v-if="getWallet(to_account_id)">
																<img :src="'../../../../static/fxView/images/'+getWallet(to_account_id).wallet.currency.toLowerCase()+'.svg'" class="mr-2" alt="Icon">
																{{getWallet(to_account_id).wallet.wallet_no}} 
															</span>
															<span v-else>
																<img :src="'../../../../static/fxView/images/'+$env_var.platformIcon[to_platform]" class="mr-2" alt="Icon">
																{{to_account_id}} 
															</span>
															<small v-html="(parseInt(to_demo_live) == 1)? $t('live') : $t('demo') " v-if="getWallet(to_account_id) === ''"></small>
														</div>
													</div>
													<ul class="scrollbar" >
														<li v-for="(list,key) in allAccountList.records" v-if="parseInt(list.demo_live) == 1 && list.account_id != account_id" v-on:click.prevent="asignValueParentComponent(list)">
															<div class="aclist" v-if="list.margin_detail"> 
																<span>
																	<img :src="'../../../../static/fxView/images/'+list.currency.toLowerCase()+'.svg'" class="mr-2"  alt="Icon"> {{list.wallet_no}}  
																</span>
																<!-- <small v-html="(parseInt(list.demo_live) == 1)? $t('live') : $t('demo') "></small> -->
															</div>
															<div class="aclist" v-else> 
																<span>
																	<img :src="'../../../../static/fxView/images/'+$env_var.platformIcon[list.platform]" class="mr-2"  alt="Icon"> {{list.account_id}}  
																</span>
																<small v-html="(parseInt(list.demo_live) == 1)? $t('live') : $t('demo') "></small>
															</div>
														</li>
													</ul>
													<p class="error" v-if="(submitted && to_account_id == '')">{{$t('It_fieldReq')}}</p>
												</div>
											</div> 
											<div class="form-group field-wrapper" v-if="toBalance != ''">
												<input placeholder=" " type="text" v-model="toBalanceCurr"  v-validate="{ required: true }" name="toBalanceCurr" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('toBalanceCurr') }" ref="toBalanceCurrInput" readonly />
												<label for="password" class="float-label"> {{$t('It_currentBalance')}}</label>
											</div> 
											<div class="form-group field-wrapper" >
												<input type="text" placeholder=" " class="mdb-select md-form float-field form-control" v-model="amount" v-validate="{ required :true , max_value : fromBalance }" name="amount"  :class="{ 'is-invalid': submittedInternalOtp && errors.has('amount') }" ref="amountInput">
												<label for="amount" class="float-label">{{$t('It_pleseEnterAmount')}} </label>
												<ul><li v-for="error in errors.collect('amount')">{{ error }}</li></ul>
											</div> 
											<div class="form-group text-center field-wrapper">
												<button class="prism_btn btn_sm" v-on:click.prevent="submitInternalTransferRequestOtp()">		
													<span v-if="!conversionAmount">{{$t('It_submit')}}</span>
													<span v-else>{{$t('It_confToTransfer')}}</span>
												</button>
											</div>
										</div>
										<div class="signupbtn mt-4 text-center" v-if="come_from_manage_page">
											<router-link to="/account" class="underline">{{$t('lev_backManageAccount')}} </router-link>
										</div>
									</div>
									<div class="clearfix"></div>
								</div>
								<!-------------------------------------------------------------------->
								<div class="partcipate-fund" v-if="transaction_id != '' && !congModuleIntTransfer">
									<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 1)">
										<p class="mb-3 text-center">{{$t('rb_googleAuth1')}} <strong>{{$t('rb_googleAuth2')}}</strong> {{$t('rb_googleAuth3')}}. </p>
										<div class="form-group field-wrapper">
											<input type="text" placeholder="000 000" class="mdb-select md-form form-control" v-model="otp" v-validate="{ required: true, max: 6,numeric : true }" name="otp"  :class="{ 'is-invalid': submittedInternalOtp && errors.has('otp') }" ref="otpInput">
											<ul><li v-for="error in errors.collect('otp')">{{ error }}</li></ul>
										</div> 
										<div class="form-group text-center field-wrapper">
											<button class="prism_btn btn_sm " v-on:click.prevent="submitInternalTransferCheckOtp()">{{$t('rb_validate')}}  </button>
										</div>
										<div class="clearfix"></div>
										<div class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"> 
											<div class="desc text-center">
												<p>{{$t('rb_googleAuth4')}} <a v-on:click.prevent="resendLink()" href="#"><strong>{{$t('rb_googleAuth5')}}</strong></a></p>
											</div>
										</div>
										<div class="clearfix"></div>
									</div>
									<div class="middleBox1" v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && !authComponent)">
										<div class="congratulations">
											<div class="logo_congrats transferLogo">
												<img src="../../../../static/fxView/images/internal_transfer.svg" alt="Icon">
											</div>
											<div class="subtitle">
												<p class="mb-3">{{$t('verf_dear')}} <strong class="green">{{get_user.username}}</strong>
													{{$t('rb_googleAuth6')}} <strong>{{get_user.email}} . </strong> {{$t('It_intTransMsz2')}}
												</p>
												<a v-on:click.prevent="resendLink()" href="#" class="mb-3"><strong>{{$t('rb_googleAuth7')}}</strong></a>
												
											</div>
										</div>
										<div class="clearfix"></div>
										<div class="d-flex align-items-center justify-content-between enble2fa border-top pt-3 mt-3">
											<div class="ico mr-3">
												<img src="../../../../static/fxView/images/google_auth.png" alt="2fa">
											</div>
											<div class="desc w-75">
												<h5 class="mb-2"><strong>{{$t('rb_googleAuth8')}}</strong></h5>
												<p>{{$t('rb_googleAuth9')}} <a v-on:click.prevent="authComponent = true" href="#"><strong>{{$t('rb_googleAuth10')}}</strong></a></p>
											</div>
										</div>
									</div> 
									<!-- <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
										<button v-on:click.prevent="back()" class="prism_btn btn_sm">cancel</button>
									</div>  -->
								</div> 

								<div class="stepForm" v-if="congModuleIntTransfer">
									<div class="congratulations">
										<div class="logo_congrats">
											<img src="../../../../static/fxView/images/check.svg" alt="Icon">
										</div>
										<div class="subtitle">
											<h3>{{$t('rb_congo')}}  <span class="green">{{get_user.username}}</span></h3>
											<p>{{$t('It_intTransMsz3')}} </p>
											<ul class="includeWdth">
												<li><strong>{{$t('It_fromTradId')}} </strong> {{res_data.account_id}}</li>
												<li><strong>{{$t('req_amount')}} </strong> {{parseFloat(res_data.amount).toFixed(2)}}</li>
												<li v-if="getWallet(res_data.to_account_id)">
													<strong>{{$t('It_towallet')}}</strong>{{getWallet(res_data.to_account_id).wallet.wallet_no}}
												</li>
												<li v-else><strong>{{$t('It_toTradId')}} </strong>{{res_data.to_account_id}}</li>
												<li><strong>{{$t('It_transferAmount')}} </strong>{{parseFloat(res_data.trans_amount).toFixed(2)}}</li>
											</ul>
										</div>
									</div>
									<div class="signupbtn full-width submitButton w-100 mt-4 text-center">
										<router-link :to="'/account'" class="prism_btn btn_sm" v-if="$route.name == 'fxView.changeLeverage'">{{$t('lev_goBackMangeAccv')}}</router-link>
										<button v-on:click.prevent="back()" class="prism_btn btn_sm" v-else>{{$t('It_backinternalTrans')}}  </button>
									</div> 
								</div>
							</div>
						</div>							 
					</div>
				</div>
			</div>
		</div>
		
		<div v-else class="text-center p-5 customLoader"> 
			<div class="loader"></div>  
            <h4>{{$t('rb_plzWaitWhileProc')}}</h4>
        </div>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import twoFa from '../users/2FA'
    export default {
        name: 'Internal-transfer',
        mixins: [fxViewMixins],
        data() {
            return {
				pageName : this.$options.name,
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                //==========================================
                come_from_manage_page : false,

				//-----select account----
				selectAccount : false,
                account_id : '',
				act_account_id : '',
				demo_live : '',
				platform :'', 
				from_currency : '',
				//-----------------------
				selectToAccount : false,
                to_account_id : '',
				to_act_account_id : '',
				to_demo_live : '',
				to_platform :'', 
				to_currency : '',
				
				
                amount : '',
                submitted : false,

                otp : '',
                submittedInternalOtp : false,
                transaction_id : '',
                congModuleIntTransfer : false,
                res_data : '',
                authComponent : false,
                request_page : 'internal-transfer',
				
				responseAmount : '',
				
				fromBalance : '',
				fromBalanceCurr : '',
				toBalance : '',
				toBalanceCurr : '',
				conversionAmount : false
            }
        },
        components: {
            appTwofa: twoFa
        },
        props:['accountId'],
        methods:{
        	back(){ //used for back button 
        		this.reset()
        		this.transaction_id = ''
        		this.congModuleIntTransfer = false
        		this.res_data = ''
        		this.authComponent = false
        	},
        	getWallet(account_id){// to check if the trading account_id is wallet also return wallet id and also need to get wallet id and currency
        		try{
	        		let data = Object.values(this.walletAccount).filter(val=> val.wallet.account_id == account_id )
	        		return (data.length)?data[0]:''
        		}catch(e){return '';}
        	},
			asignValueParentComponent(list){
				this.to_account_id = list.account_id 
				this.to_act_account_id = list.act_account_id  
				this.to_demo_live = list.demo_live 
				this.to_platform = list.platform 
				this.to_currency = list.currency 
				this.tradingBonus('to') 
		    },
			tradingBonus(getData){
				if(this.account_id == this.to_account_id){
					this.response_msg = "suceessMsz25"
					this.msg_type = "error"
				}else{
					let input_json;
					if(getData == 'from'){
						input_json = {
							'globalParams' : {
								'account_id' : this.account_id, 
								'act_account_id': this.act_account_id,  
								'demo_live' : this.demo_live , 
								'platform' : this.platform
							} ,'localParams' : {'parameter' : this, 'module' : getData}
						}
					}else{
						input_json = {
							'globalParams' : {
								'account_id' : this.to_account_id, 
								'act_account_id': this.to_act_account_id,  
								'demo_live' : this.to_demo_live , 
								'platform' : this.to_platform
							} ,'localParams' : {'parameter' : this, 'module' : getData}
						}
					}
					this._runGetAccountDetails(input_json)
				}
            },
            resendLink(){
                let input_json = {
                    'globalParams' : {
                        'trans_id' : this.transaction_id.toString()
                    } ,'localParams' : {'parameter' : this}
                }
                this._runResendEmailLinkAccount(input_json)
            },
            //================leverage===================================
            submitInternalTransferRequestOtp(){
					const _that = this
					this.submitted = true;
					if(this.conversionAmount){
						this.$validator.validate().then(valid => {
							if (valid) {
								if(parseFloat(_that.amount) > parseFloat(_that.fromBalance)){
									_that.response_msg = _that.$t('amountHigherThanMargin'),
									_that.msg_type = 'error'
								}else{
									let input_json={
										'globalParams' :{
											'act_account_id': _that.act_account_id, 
											'to_act_account_id': _that.to_act_account_id, 
											'account_id' : _that.account_id , 
											'to_account_id' : _that.to_account_id ,
											'currency' : _that.from_currency,
											'to_currency' : _that.to_currency,
											'amount' : _that.amount, 
											"operation" : "INTERNAL TRANSFER"
										},
										'localParams' :{ "parameter" : _that }
									}
									_that._runAccountPasswordRequestOtp(input_json)
								}
							}else{
								_that.handleValidationErrorAdvanced(_that.errors)
							}
						});
					}else{
						this.$validator.validate().then(valid => {
							if (valid) {
								if(parseFloat(this.amount) > parseFloat(this.fromBalance)){
									this.response_msg = _that.$t('amountHigherThanMargin'),
									this.msg_type = 'error'
								}else{
									let input_json={
										'globalParams' :{
											from_currency : this.from_currency, 
											to_currency : this.to_currency,
											amount : this.amount
										},
										'localParams' :{ "parameter" : this }
									}
									this._runAmountConversionApi(input_json)
								}
							}else{
								_that.handleValidationErrorAdvanced(_that.errors)
							}
						});
					}
				
            },
            submitInternalTransferCheckOtp(){
                const _that = this
                this.submittedInternalOtp = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'google_token' : _that.otp.toString() ,
                                'trans_id' : _that.transaction_id.toString()
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runInternalTransferCheckOtp(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            reset(){
				//-----select account----
				this.selectAccount =  false
                this.account_id =  ''
				this.act_account_id =  ''
				this.demo_live =  ''
				this.platform = '' 
				this.from_currency =  ''
				//-----------------------
				this.selectToAccount =  false
                this.to_account_id =  ''
				this.to_act_account_id =  ''
				this.to_demo_live =  ''
				this.to_platform = '' 
				this.to_currency =  ''
                this.amount = ''
                this.submitted = false
            }
        },
        created(){
            if(this.$route.params.account_id){
                this.come_from_manage_page = true
                this.account_id = this.$route.params.account_id
				this.act_account_id = this.$route.params.act_account_id
				this.demo_live = this.$route.params.demo_live
				this.platform = this.$route.params.platform 
				this.from_currency = this.$route.params.from_currency
				this.tradingBonus('from')
            }
			// this._runGetTradingAccountList({'globalParams' : {} ,'localParams' : {'parameter' : this}})
        },
		mounted() { 
			const _that = this
            $(document).on("click", function(event){
				if(!$(event.target).closest('.SelectAcntList2').length){
                    _that.selectToAccount = false
                }
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/manageAccounts/internal_transfer.vue